export default __webpack_public_path__ + "static/media/no-image.176a52af.svg";